module.exports = __webpack_public_path__ + "assets/dae45a86b921f747ef8c59507bb3885c.mp3";